<template>
  <div class="image-content">
    <img :src="bg" class="bg-img">
    <div class="content-body">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageContent',
  props: {
    bg: {
      require: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import './ImageContent.scss';
</style>